import { useThemeColor, useToast } from '@wistia/vhs';
import { useCallback } from 'react';
import { isNonEmptyString } from '~/utilities/type-guards';
import { usePurchaseLink } from '~/pricing';
import { trackStructEvent } from '~/utilities/snowplow';
import { GLOBAL_CALLBACKS_IDENTIFIER, getCallbacks } from './getCallbacks';

export const UploadProviderGlobalCallbacks = (): null => {
  const purple600 = useThemeColor('purple600');
  const showToast = useToast();
  const { buildLink } = usePurchaseLink();
  const { useOnMediaLimitExceeded } = getCallbacks(GLOBAL_CALLBACKS_IDENTIFIER);

  const handleToastInterceptor = useCallback(async () => {
    const { path, isGetInTouch } = await buildLink();

    const labelModifier = isGetInTouch ? 'git' : 'upgrade';
    trackStructEvent({
      category: 'toast',
      action: 'click',
      label: `growth-inflexible-media-toast-${labelModifier}`,
    });
    window.location.assign(path);
  }, [buildLink]);

  useOnMediaLimitExceeded(
    useCallback(
      (message) => {
        // This message get's reset to an empty string so we only want
        // to show it when it isn't empty.
        if (isNonEmptyString(message)) {
          trackStructEvent({
            category: 'toast',
            action: 'view',
            label: 'growth-inflexible-media-toast',
          });

          showToast({
            message,
            colorOverride: purple600,
            actionLabel: 'Upgrade',
            actionInterceptor: () => {
              void handleToastInterceptor();
            },
          });
        }
      },
      [showToast, handleToastInterceptor, purple600],
    ),
  );

  return null;
};
